// extracted by mini-css-extract-plugin
export default {"LicenseStatus":"licensestatus_LicenseStatus__k9i4s","valid":"licensestatus_valid__1F9r+","soon":"licensestatus_soon__SgN+k","expire":"licensestatus_expire__JhuvW"};